import { ChangeDetectionStrategy, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { IMiniChartConfig } from '../dashboard-card-summary/dashboard-card-summary.component';
import { DashboardCardService } from './dashboard-card.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardCardComponent implements OnInit, OnDestroy {
  @Input()
  public smallChartStats: IMiniChartConfig[];

  @Input()
  public statsData: any;

  @Input()
  public statsTotalData: any;

  @Input()
  public initSelectedCharts: number[] = [];

  @Input()
  public initSelectedMetrics: string[] = [];

  @Input()
  public localStorageKey: string = '';

  @Input()
  public isLoading: boolean = true;

  @Input()
  public excludedMetrics: string[] | null;

  private destroyed$: Subject<void> = new Subject();

  constructor(
    public dashboardCardService: DashboardCardService,
  ) {}

  public get isEmptyData(): boolean {
    const [first, second] = this.dashboardCardService.selectedChartNamesSnapshot;
    const { [first]: firstStat, [second]: secondStat } = this.statsData;
    return !firstStat?.values?.length && !secondStat?.values?.length;
  }

  public ngOnInit(): void {
    const allMetricsKeys: string[] = this.smallChartStats.map(metric => metric.key);

    this.dashboardCardService.tryInitFromLocalStorage(
      this.localStorageKey,
      this.initSelectedCharts,
      this.initSelectedMetrics,
      allMetricsKeys,
    );

    this.dashboardCardService.state$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        () => this.dashboardCardService.saveStateToLocalStorage(this.localStorageKey)
      );
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
